
const initialState = {
  showDumbledore: false,
  isAssets: true
};

function uiReducer(state = initialState, action) {
  switch (action.type) {
    case 'UI_TOGGLE_TABS':
      return {
        ...state,
        isAssets: action.payload.tabsIndex === 0 ? true : false
      }
    case 'UI_SHOW_DUMBLEDORE':
      return {
        ...state,
        showDumbledore: true
      };
    case 'UI_HIDE_DUMBLEDORE':
      return {
        ...state,
        showDumbledore: false
      };
    default:
      return state;
  }
}
export default uiReducer;



// WEBPACK FOOTER //
// ./src/reducers/ui-reducer.js